import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import {Card, CardText} from 'material-ui/Card';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import { StickyTable, Row, Cell } from 'react-sticky-table';
import 'react-sticky-table/dist/react-sticky-table.css';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import Toggle from 'material-ui/Toggle';
import './Table.css';

class Inventory extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      loadingIndicator: 'flex',
      products: [],
      allProducts: [],
      stands: [],
      allStands: [],
      hideEmpty: true
    };

    this.state = {
      ...this.initialState
    };

  }
  componentDidMount = () => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    if(!shopkeeperId) return;
    if(this.standsRef) return;

    this.standsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/`).orderByChild('name');
    this.standsRef.once('value', (stands) => {
      stands.forEach((data) => {
        const stand = {
          key: data.key,
          ...data.val()
        };
        if (stand.products) {
          const currentStands = this.state.stands.slice();
          currentStands.push(stand);
          this.setState({stands: currentStands});
        }
        if (typeof stand.products === 'undefined') {
          stand.products = [];
        }

        const allStands = this.state.allStands.slice();
        allStands.push(stand);
        this.setState({allStands});
      });
    }).then(() => {
      this.productsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/products`).orderByChild('name');
      this.productsRef.once('value', (products) => {
        products.forEach((data) => {
          let product = {
            key: data.key,
            ...data.val()
          };
          const currentStands = this.state.stands.slice();
          let total = 0;
          let productInSomeStand = false;
          currentStands.forEach((stand) => {
            if (typeof stand.products[product.key] !== 'undefined') {
              if (!productInSomeStand) {
                productInSomeStand = true;
              }
              total += +(stand.products[product.key].totalCount || 0);
            }
          });
          product.total = total;
          if (productInSomeStand) {
            const currentProducts = this.state.products.slice();
            currentProducts.push(product);
            this.setState({products: currentProducts});
          }
          const allProducts = this.state.allProducts.slice();
          allProducts.push(product);
          this.setState({allProducts});
        });
      }).then(this.setState({loadingIndicator: 'none'}));
    });
  }

  setHideEmpty = (event, hideEmpty) => {
    this.setState({hideEmpty});
  }


  render() {
    const {t} = this.props;

    const headerInventory =
    <Row>
      <Cell className='headerCell firstColumnCell'>{t('product.product')}</Cell>
      {(this.state.hideEmpty ? this.state.stands : this.state.allStands).map((stand) => (
        <Cell className='headerCell' key={stand.key}>{stand.name}</Cell>
      ))}
      <Cell className='totalValueCell headerCell'>
        {t('inventory.total')}
      </Cell>
    </Row>;
    const inventory = (this.state.hideEmpty ? this.state.products : this.state.allProducts).map((product) => (
      <Row className='tableRow' key={product.key}>
        <Cell className='contentCell firstColumnCell'>
          {product.name}
        </Cell>
        {(this.state.hideEmpty ? this.state.stands : this.state.allStands).map((stand) => (
          <Cell className='contentCell numberValueCell' key={stand.key}>
            {(typeof stand.products[product.key] === 'undefined') ?
              <span className='spanNumberCell'>-</span> :
              <span className='spanNumberCell'
                title={product.name + '\n' + stand.name}>
                {stand.products[product.key].totalCount || 0}
              </span>}
          </Cell>
        ))}
        <Cell className='contentCell numberValueCell totalValueCell'>
          <span className='spanNumberCell'>
            {product.total}
          </span>
        </Cell>
      </Row>
    ));
    return (
      <Card className='bigCardStyle' >
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('inventory.inventory')} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <Toggle
            label={t('inventory.hideProductsAndStands')}
            toggled={this.state.hideEmpty}
            onToggle={this.setHideEmpty}
            style={{maxWidth: '300px'}}
          />
          <br />
          <div className='stickyTable'>
            <StickyTable>
              {headerInventory}
              {inventory}
            </StickyTable>
          </div>
          <LoadingIndicator display={this.state.loadingIndicator} />
        </CardText>
      </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Inventory);



// WEBPACK FOOTER //
// ./src/Inventory/Inventory.js